module.exports = __webpack_public_path__ + "media/โฮ่งๆ.7092cd8b.mp3";